import { createReducer, on } from '@ngrx/store';
import { DashboardActions } from './dashboard.actions';
import { DashEquipmentResponse  } from '../../../shared/interfaces/dashboard.interfaces';

export const dashboardFeatureKey = 'dashboard';

export interface DashboardState {
  connCounter?: { [key: string]: number } | undefined;
  stats?: DashEquipmentResponse | undefined
}

export const initialState: DashboardState = {};

export const dashboardReducer = createReducer(
  initialState,

  on(DashboardActions.loadConnCounterSuccess, (state, action) => { 
    return { ...state, connCounter: action.data };
  }),

  // Store dashboard statistics (status and signal)
  on(DashboardActions.loadDashboardEquipmentsSuccess, (state, action) => {
    return { ...state, stats: action.data };
  }),

  on(DashboardActions.unsetDashboard, () => initialState)
);